"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var UserMenu_1 = __importDefault(require("./UserMenu"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var client_1 = require("@apollo/client");
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query UserMenuLoaderQuery {\n    viewer {\n      id\n      ...UserMenu_viewer\n    }\n  }\n  ", "\n"], ["\n  query UserMenuLoaderQuery {\n    viewer {\n      id\n      ...UserMenu_viewer\n    }\n  }\n  ", "\n"])), UserMenu_1.default.fragments.viewer);
var UserMenuLoader = function (props) {
    var _a = client_1.useQuery(QUERY), loading = _a.loading, error = _a.error, data = _a.data;
    if (loading || !data)
        return react_1.default.createElement(UserMenu_1.default, { viewer: props.viewer });
    return react_1.default.createElement(UserMenu_1.default, { viewer: data.viewer });
};
exports.default = UserMenuLoader;
var templateObject_1;
